const TipoItem = {
    PlanInternet: "planInt",
    ServiciosGen: "servGen",
    Articulo: "art",
};

const Udm = {
    Mensual: "mensual",
    Unidad: "unid",
};

const Moneda = {
    Soles: "sol",
    Dolares: "usd",
};

export {TipoItem, Udm, Moneda };
